import { createSelector } from 'reselect'

const getInteractiveVideoCreation = state => state.interactiveVideoCreation

const VideoTimmingSelector = createSelector(
	[getInteractiveVideoCreation],
	interactiveVideoCreation => {
		const videoTotalDuration = interactiveVideoCreation.media.duration

		return {
			isTrimmed: interactiveVideoCreation.media.trimEnd < videoTotalDuration ||
				interactiveVideoCreation.media.trimStart > 0,
			isTrimToolOpen: interactiveVideoCreation.trimTool.isActive,
			hasDifferentTrim:
				interactiveVideoCreation.media.trimStart !== interactiveVideoCreation.trimTool.trimStart ||
				interactiveVideoCreation.media.trimEnd !== interactiveVideoCreation.trimTool.trimEnd,
		}
	}
)

export default VideoTimmingSelector
